import { Auth0Provider } from '@auth0/auth0-react';
import PropTypes from 'prop-types';
import React from 'react';
import history from 'src/app/router/utils/history';

import { mainDomain } from './helper/utilityFunctions';
import { MULTI_TENANT_AUTH } from './utils/constants/multiTanentAuthInfo';

const Auth0ProviderWithNavigate = ({ children }) => {
  const tenant = mainDomain();
  const environmentData = MULTI_TENANT_AUTH[tenant];

  const domain = environmentData?.auth0Domain;
  const clientId = environmentData?.auth0ClientId;
  const redirectUri = window.location.origin;
  const audience = environmentData?.auth0Audience;

  const onRedirectCallback = (appState) => {
    history.push(appState?.returnTo || window.location.pathname);
  };

  if (!(domain && clientId && redirectUri && audience)) {
    return null;
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: redirectUri,
        audience: audience,
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  );
};

Auth0ProviderWithNavigate.propTypes = {
  children: PropTypes.node,
};

export { Auth0ProviderWithNavigate };
